<template>

    <div class="print-elements" :exceeds-bounding-box="canvasObject.getExceedsBoundingBox()">
        <img :src="canvasObject.getCardTitleInObjectsConfigurator().image" alt=""> {{canvasObject.getCardTitleInObjectsConfigurator().title}}
        <div class="absolute-right">
            <a v-if="isAdminMode === true && canvasObject.constructor.TYPE_TITLE === 'image'" @click="toggleLocked()">
                <i class="material-icons" v-if="canvasObject.getIsLocked() === true">
                    locky
                </i>
                <i class="material-icons" v-if="canvasObject.getIsLocked() === false">
                    lock_open
                </i>
            </a>
            <a v-if="canvasObject.getCanvas().getCanSortElements() || isAdminMode === true" @click="$emit('levelPlus', { id: canvasObject.getId() })" :disabled="canvasObject.getZPosition() === canvasObjectsLength - 1">
                <i class="material-icons">
                    arrow_upward
                </i>
            </a>
            <a v-if="canvasObject.getCanvas().getCanSortElements() || isAdminMode === true" @click="$emit('levelMinus', { id: canvasObject.getId() })" :disabled="canvasObject.getZPosition() === 0">
                <i class="material-icons">
                    arrow_downward
                </i>
            </a>
            <a @click="showCanvasObjectView">
                <i class="material-icons">
                    edit
                </i>
            </a>
        </div>
    </div>

</template>

<script>
    export default {
        name: "CanvasObject",
        props: {
            canvasObject: {
                type: Object,
                default: () => ({})
            },
            canvasObjectsLength: {
                type: Number,
                default: 1
            }
        },
/*        data: () => ({
            component: null
        }),*/
        computed: {

            isAdminMode() {

                if (window['w2p_admin'] === true)
                    return true;

                return false;

            }

        },
        methods: {
          async showCanvasObjectView() {

              this.$emit('showCanvasObjectView', {
                 data: this.canvasObject
              });

          },

          toggleLocked() {

              if (this.canvasObject.getIsLocked() === true) {
                  this.canvasObject.setIsLocked(false);
                  console.log('set to false');
              } else {
                  this.canvasObject.setIsLocked(true);
                  console.log('set to true');
              }

              this.canvasObject.getCanvas().render();

          }
        },
        async mounted() {
            /*try {
                this.component = await this.loadComponent();
            } catch (e) {
                throw 'Cant load component for object type.';
            }*/
        }
    }
</script>

<style lang="scss" scoped>

    .print-elements {
        border-radius: 5px;
        background-color: #ffffff;
        margin-bottom: 10px;
        padding: 10px 15px;
        color: #004B92;
        font-size: 1rem;
        display: flex;
        align-content: center;
        align-items: center;
        position: relative;

        &[exceeds-bounding-box=true] {
            background-color: lighten(red, 40);
        }

        img {
            margin-right: 10px;
        }

        .absolute-right {
            position: absolute;
            top: 5px;
            right: 5px;

            a {
                color: #5F7285;

                &:hover {
                    cursor: pointer;
                }

                &[disabled=disabled] {
                    display: none;
                    cursor: default;
                }
            }
        }
    }

    .print-elements strong {
        color: #004B92;
        font-weight: normal;
    }

</style>